import api from './apiClient';

type ChannelRouteTarget = number | string | { id?: number | string; hashId?: string | null; channelHashId?: string | null };

export type ChannelAuditLog = {
  id: number;
  action: string;
  details: string;
  createdAt: string;
  userId: string | number;
};

export type ChannelAuditLogPage = {
  items: ChannelAuditLog[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  archiveSize?: number;
};

const resolveChannelRouteId = (channel: ChannelRouteTarget) => {
  if (channel && typeof channel === 'object') {
    return String(channel.channelHashId || channel.hashId || channel.id || '');
  }
  return String(channel ?? '');
};

export const getChannelLogs = async (
  channel: ChannelRouteTarget,
  options?: { page?: number; limit?: number }
) => {
  const routeId = resolveChannelRouteId(channel);
  const { data } = await api.get(`/audit/channel/${routeId}`, { params: options });
  return data;
};

export const downloadChannelLogsCsv = async (channel: ChannelRouteTarget) => {
  const routeId = resolveChannelRouteId(channel);
  const { data } = await api.get(`/audit/channel/${routeId}.csv`, { responseType: 'blob' });
  return data as Blob;
};
